<template>
  <article class="customer-detail-card customer-detail-card--accent-success">
    <header class="customer-detail-card-header customer-detail-card-header--inline">
      <h4>
        <i class="fa fa-file-text-o customer-section-icon customer-section-icon--billing" aria-hidden="true"></i>
        {{ text.card.title }}
      </h4>

      <div class="customer-section-card-actions">
        <button
          type="button"
          class="app-table-icon-btn app-table-icon-btn--view customer-section-edit-btn customer-section-edit-btn--billing-list"
          :title="text.card.actions.openList"
          @click="$emit('open-billing-data-list')"
        >
          <i class="fa fa-list-ul" aria-hidden="true"></i>
        </button>

        <button
          type="button"
          class="app-table-icon-btn app-table-icon-btn--view customer-section-edit-btn customer-section-edit-btn--billing-add"
          :title="text.card.actions.create"
          @click="$emit('create-billing-data')"
        >
          <i class="fa fa-plus" aria-hidden="true"></i>
        </button>

        <button
          type="button"
          class="app-table-icon-btn app-table-icon-btn--edit customer-section-edit-btn customer-section-edit-btn--billing-edit"
          :title="text.card.actions.edit"
          @click="$emit('edit-billing-data')"
        >
          <i class="fa fa-pencil" aria-hidden="true"></i>
        </button>
      </div>
    </header>

    <div class="customer-detail-info-grid customer-detail-info-grid--billing">
      <div
        v-for="item in items"
        :key="item.label"
        class="customer-detail-info-item"
      >
        <span>{{ item.label }}</span>
        <button
          v-if="item.isAction"
          type="button"
          class="customer-detail-info-action"
          @click="$emit('edit-billing-data')"
        >
          {{ item.value }}
        </button>
        <span v-else class="customer-detail-info-value">{{ item.value }}</span>
      </div>

      <div class="customer-detail-info-item customer-detail-info-item--full">
        <span>{{ text.card.residenceLabel }}</span>
        <button
          v-if="residence.isAction"
          type="button"
          class="customer-detail-info-action"
          @click="$emit('edit-billing-data')"
        >
          {{ residence.value }}
        </button>
        <span v-else class="customer-detail-info-value">{{ residence.value }}</span>
      </div>
    </div>
  </article>
</template>

<script>
import { useDomainText } from '@/composables/text/useDomainText';

const { catalog: text } = useDomainText('billingData');

export default {
  name: 'ContributorBillingDataCard',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    residence: {
      type: Object,
      default: () => ({
        label: 'Residencia fiscal',
        value: '-',
        isAction: false,
      }),
    },
  },
  emits: ['edit-billing-data', 'open-billing-data-list', 'create-billing-data'],
  data() {
    return {
      text,
    };
  },
};
</script>
